import Image from "next/image"
import Link from "next/link"


const GendonganMshapeNewborn = () => {

  return (
    <>
      <div className="container py-4 mx-auto space-y-4 md:hidden">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-may-m01.webp"}
          alt="Salah Pilih Gendongan, Bisa Sebabkan Kaki O pada Bayi"
          quality={100}
          width={1147}
          height={836}
        />
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-may-m02.webp"}
          alt="Pilih gendongan yang menopang kaki dalam posisi M Shape agar si kecil nyaman dan aman"
          quality={100}
          width={1147}
          height={836}
        />
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-may-m03.webp"}
          alt="Kenapa Memilih Gendongan SSC untuk Optimalkan Posisi M Shape Anak"
          quality={100}
          width={1147}
          height={836}
        />
        <div className="w-full">
          <Link href="https://s.mooimom.id/Jcsfx">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-may-m04.webp"}
              alt="AiryKnit Baby Carrier White Vanilla"
              quality={100}
              width={1147}
              height={836}
            />
          </Link>
        </div>
        <div className="w-full">
          <Link href="https://s.mooimom.id/w2qrS">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-may-m05.webp"}
              alt="Wonder Carrier"
              quality={100}
              width={1147}
              height={836}
            />
          </Link>
        </div>
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-may-m06.webp"}
          alt="Kenapa Memilih Gendongan SSC untuk Optimalkan Posisi M Shape Anak"
          quality={100}
          width={1147}
          height={836}
        />
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-m07.webp"}
          alt="White Vanilia Spesial Harga di Website"
          quality={100}
          width={1147}
          height={836}
        />
        <div className="w-full">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-m05-1.webp"}
            alt="AiryKnit Baby Carrier"
            quality={100}
            width={1147}
            height={195}
          />
          <div className="flex max-w-full">
            <div className="w-[32%]">
              <Link href="https://s.mooimom.id/Jcsfx">
                <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-m05-2.webp"}
                  alt="AiryKnit Baby Carrier White Vanilla"
                  quality={100}
                  width={364}
                  height={641}
                />
              </Link>
            </div>
            <div className="w-[68%]">
              <Link href="https://s.mooimom.id/65mnV">
                <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-m05-3.webp"}
                  alt="AiryKnit Baby Carrier Stellar White, Starry Gray and Cosmic Black"
                  quality={100}
                  width={783}
                  height={641}
                />
              </Link>
            </div>
          </div>
        </div>
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-m08.webp"}
          alt="Wonder Carrier Spesial Harga di Website"
          quality={100}
          width={1147}
          height={836}
        />
        <div className="w-full">
          <Link href="https://s.mooimom.id/w2qrS">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-m06.webp"}
              alt="Wonder Carrier"
              quality={100}
              width={1147}
              height={836}
            />
          </Link>
        </div>
      </div>
      <div className="container hidden py-8 space-y-10 md:block">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-may-d01.webp"}
          alt="Salah Pilih Gendongan, Bisa Sebabkan Kaki O pada Bayi"
          quality={100}
          width={1330}
          height={655}
        />
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-may-d02.webp"}
          alt="Pilih gendongan yang menopang kaki dalam posisi M Shape agar si kecil nyaman dan aman"
          quality={100}
          width={1330}
          height={655}
        />
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-may-d03.webp"}
          alt="Kenapa Memilih Gendongan SSC untuk Optimalkan Posisi M Shape Anak"
          quality={100}
          width={1330}
          height={655}
        />
        <div className="w-full">
          <Link href="https://s.mooimom.id/Jcsfx">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-may-d04.webp"}
              alt="AiryKnit Baby Carrier White Vanilla"
              quality={100}
              width={1330}
              height={655}
            />
          </Link>
        </div>
        <div className="w-full">
          <Link href="https://s.mooimom.id/w2qrS">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-may-d05.webp"}
              alt="Wonder Carrier"
              quality={100}
              width={1330}
              height={655}
            />
          </Link>
        </div>
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-may-d06.webp"}
          alt="Kenapa Memilih Gendongan SSC untuk Optimalkan Posisi M Shape Anak"
          quality={100}
          width={1330}
          height={655}
        />
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-d07.webp"}
          alt="White Vanilia Spesial Harga di Website"
          quality={100}
          width={1330}
          height={655}
        />
        <div className="w-full">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-d05-1.webp"}
            alt="AiryKnit Baby Carrier"
            quality={100}
            width={1330}
            height={136}
          />
          <div className="flex max-w-full">
            <div className="w-[29.6%]">
              <Link href="https://s.mooimom.id/Jcsfx">
                <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-d05-2.webp"}
                  alt="AiryKnit Baby Carrier White Vanilla"
                  quality={100}
                  width={394}
                  height={520}
                />
              </Link>
            </div>
            <div className="w-[70.4%]">
              <Link href="https://s.mooimom.id/65mnV">
                <Image
                  src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-d05-3.webp"}
                  alt="AiryKnit Baby Carrier Stellar White, Starry Gray and Cosmic Black"
                  quality={100}
                  width={937}
                  height={520}
                />
              </Link>
            </div>
          </div>
        </div>
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-d08.webp"}
          alt="Wonder Carrier Spesial Harga di Website"
          quality={100}
          width={1330}
          height={655}
        />
        <div className="w-full">
          <Link href="https://s.mooimom.id/w2qrS">
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/compare/gendongan/gendongan-d06.webp"}
              alt="Wonder Carrier"
              quality={100}
              width={1330}
              height={655}
            />
          </Link>
        </div>
      </div>
    </>
  )
}

export default GendonganMshapeNewborn
